import {
  pasta1,
  pasta2,
  pasta3,
  pasta4,
  pasta5,
  pasta6,
  burger1,
  burger2,
  burger3,
  burger4,
  burger5,
  burger6,
  meatball1,
  meatball2,
  meatball3,
  meatball4,
  meatball5,
  meatball6,
  pizza1,
  pizza2,
  pizza3,
  pizza4,
  pizza5,
  pizza6,
} from '../assets/images/images';

export function getCategoryProducts(name) {
  return products.filter((el) => el.category === name);
}

export const categories = ['pasta', 'burger', 'meatBalls', 'pizza'];

export const products = [
  // PASTA
  {
    name: 'Chille Pasta',
    category: 'pasta',
    description: 'This is chille pasta',
    price: 1000,
    image: pasta1,
  },
  {
    name: 'Chille Pasta',
    category: 'pasta',
    description: 'This is chille pasta',
    price: 1000,
    image: pasta2,
  },
  {
    name: 'Chille Pasta',
    category: 'pasta',
    description: 'This is chille pasta',
    price: 1000,
    image: pasta3,
  },
  {
    name: 'Chille Pasta',
    category: 'pasta',
    description: 'This is chille pasta',
    price: 1000,
    image: pasta4,
  },
  {
    name: 'Chille Pasta',
    category: 'pasta',
    description: 'This is chille pasta',
    price: 1000,
    image: pasta5,
  },
  {
    name: 'Chille Pasta',
    category: 'pasta',
    description: 'This is chille pasta',
    price: 1000,
    image: pasta6,
  },
  // BURGER
  {
    name: 'Burger',
    category: 'burger',
    description: 'This is chille pasta',
    price: 1000,
    image: burger1,
  },
  {
    name: 'burger',
    category: 'burger',
    description: 'This is burger',
    price: 1000,
    image: burger2,
  },
  {
    name: 'burger',
    category: 'burger',
    description: 'This is burger',
    price: 1000,
    image: burger3,
  },
  {
    name: 'burger',
    category: 'burger',
    description: 'This is burger',
    price: 1000,
    image: burger4,
  },
  {
    name: 'burger',
    category: 'burger',
    description: 'This is burger',
    price: 1000,
    image: burger5,
  },
  {
    name: 'burger',
    category: 'burger',
    description: 'This is chille pasta',
    price: 1000,
    image: burger6,
  },
  // MEAT BALLS
  {
    name: 'meat balls',
    category: 'meatBalls',
    description: 'This is meat balls',
    price: 1000,
    image: meatball1,
  },
  {
    name: 'meat balls',
    category: 'meatBalls',
    description: 'This is meat balls',
    price: 1000,
    image: meatball2,
  },
  {
    name: 'meat balls',
    category: 'meatBalls',
    description: 'This is meat balls',
    price: 1000,
    image: meatball3,
  },
  {
    name: 'meat balls',
    category: 'meatBalls',
    description: 'This is meat balls',
    price: 1000,
    image: meatball4,
  },
  {
    name: 'meat balls',
    category: 'meatBalls',
    description: 'This is meat balls',
    price: 1000,
    image: meatball5,
  },
  {
    name: 'meat balls',
    category: 'meatBalls',
    description: 'This is meat balls',
    price: 1000,
    image: meatball6,
  },
  // PIZZA
  {
    name: 'Pizza',
    category: 'pizza',
    description: 'This is Pizza',
    price: 1000,
    image: pizza1,
  },
  {
    name: 'Pizza',
    category: 'pizza',
    description: 'This is Pizza',
    price: 1000,
    image: pizza2,
  },
  {
    name: 'Pizza',
    category: 'pizza',
    description: 'This is Pizza',
    price: 1000,
    image: pizza3,
  },
  {
    name: 'Pizza',
    category: 'pizza',
    description: 'This is Pizza',
    price: 1000,
    image: pizza4,
  },
  {
    name: 'Pizza',
    category: 'pizza',
    description: 'This is Pizza',
    price: 1000,
    image: pizza5,
  },
  {
    name: 'Pizza',
    category: 'pizza',
    description: 'This is Pizza',
    price: 1000,
    image: pizza6,
  },
];
